import { Moment } from 'moment';

export interface IAnyoTherapist {
  _id?: string;
  tagLine: string;
  u_id?: string;
  userId?: string;
  title: string;
  firstName: string;
  lastName?: string;
  email: string;
  contactNo: string;
  qualification: string[];
  yearsOfExperience: number | string;
  areaOfExpertise: string[];
  availability: TherapistAvailability[];
  availabilityV2?: TherapistAvailabilityV2[];
  bio: string;
  isFlexibleWithTiming: boolean | Event;
  isAvailable: boolean | Event;
  status: string;
  preferredModesOfTherapy: string[];
  picture?: string;
  availableFrom: Date | Moment;
  createdAt?: Date;
  createdBy?: string;
  lastModifiedAt?: Date;
  lastModifiedBy?: string;
  lastSeen: Date | Moment | string;
  rating: number;
  languages: string[];
  notAvailableSlots?: NotAvailableSlots[];
  videoBio?: string;
  verticalIds: string[];
  concernIds: string[];
  concernExpertLevelMap: Record<
    string,
    {
      level: string;
      id: string;
    }
  >;
  pricing?: {
    minPricing: number;
    maxPricing: number;
  };
  userInterestTopics: CircleTopics[];
  designationLevel: string;
  costPerSession?: {
    currency: string;
    currencySymbol: string;
    amount: {
      max: number;
      min: number;
    };
  };
  offlineAvailable: boolean;
  offlineAddress?: string;
  offlineMapLink?: string;
  mapAddress?: string;
  therapistPricing: TherapistPricing;
}

interface CircleTopics {
  key: string;
  value: string;
}

export interface TherapistAvailabilityV2{
  day: string;
  slots: SlotsV2[];
}

export interface SlotsV2 {
  slotStart: string;
  slotEnd: string;
  online: boolean;
  offline: boolean;
}

export interface NotAvailableSlots {
  date: Date;
  day: string;
  start: string;
  end: string;
}

export interface TherapistAvailability {
  day?: string;
  slot1Start: string;
  slot1End: string;
  ifSlot2: boolean;
  slot2Start: string;
  slot2End: string;
}

export enum TherapistStatus {
  'Active' = 'active',
  'Inactive' = 'inactive',
}

export interface GetTherapistResponse {
  masterdata: MasterData;
  data: IAnyoTherapist;
}

export interface MasterData {
  Languages: Array<Data>;
  AreasOfExpertise: Array<Data>;
  Qualifications: Array<Data>;
}

interface Data {
  status: string;
  data: string;
  m_id?: string;
}

// Enum to define pricing types
export enum PricingType {
  SESSION_MINUTES_SLAB = 'SESSION_MINUTES_SLAB_PRICING',
  SESSION_NUMBER = 'SESSION_NUMBER_PRICING',
  FLAT = 'FLAT_PRICING',
}

// Session Minutes Slab Pricing
export interface SessionMinutesSlabPricing {
  type: PricingType.SESSION_MINUTES_SLAB;
  slabs: {
    minDuration: number; // inclusive
    maxDuration: number; // exclusive
    rate: number;
  }[];
}

// Session Number Pricing
export interface SessionNumberPricing {
  type: PricingType.SESSION_NUMBER;
  slabs: {
    minSessionNumber: number;
    maxSessionNumber: number;
    rate: number;
  }[];
}

// Flat Pricing
export interface FlatPricing {
  type: PricingType.FLAT;
  amount: number;
}

// Union Type for all pricing models
export type PricingModel =
  | SessionMinutesSlabPricing
  | SessionNumberPricing
  | FlatPricing;

// Expert Pricing Interface
export interface TherapistPricing {
  retail?: PricingModel;
  corporate?: PricingModel;
}